"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var get = require('../getValueOfKeyMatching');

function EnvelopeReprints(params) {
  var quantity = parseInt(get(params, /A7_quantity/), 10);
  var envelope_style = get(params, /envelopeStyle/);

  if (quantity > 0) {
    this.invitationEnvelopes.add({
      quantity: quantity,
      return_addressing: parseBoolean(get(params, /inv_return[_aA]*ddressing$/)),
      guest_addressing: parseBoolean(get(params, /guest[_aA]*ddressing/)),
      custom_postage: parseBoolean(get(params, /custom[_pP]*ostage/))
    }); // have to sanitize this...

    var real_envelope_style = 'Single Envelopes';

    if (envelope_style.match(/double/i)) {
      if (envelope_style.match(/blank/i)) {
        real_envelope_style = 'Double - Blank Inner Envelopes';
      } else {
        real_envelope_style = 'Double - Printed Inner Envelopes';
      }
    }

    this.invitationEnvelopes.first().envelope_style = real_envelope_style;
    this.personalization.push({
      name: 'Return Address',
      value: get(params, /pers_[_lp]*inv_return[_aA]*ddressing/)
    });

    if (get(params, /env[elope_lL]*iner/).match(/classic|floral/i)) {
      this.envelopeLiners.add({
        quantity: quantity,
        liner_pattern: get(params, /floral-liner-pers|classic-liner-pers|liner-grid-pers/),
        liner_color: get(params, /classic-liner-color-pers|liner-color-grid-pers/)
      });
    }
  }

  quantity = parseInt(get(params, /A1_quantity/), 10);

  if (quantity > 0) {
    this.responseCardEnvelopes.add({
      quantity: quantity,
      return_addressing: parseBoolean(get(params, /res_returnAddressing/), 10)
    });
  }
}

module.exports = EnvelopeReprints;